import { DeploymentType } from '../layouts/MainLayout/MainLayout';
import axios from 'axios';

const config =
	DeploymentType !== 'staging'
		? require('../config/config.development')
		: require('../config/config.production');
const api = axios.create({
	baseURL: config.brochureAPI,
	timeout: 5000,
	headers: { 'Content-Type': 'application/json' },
});

const brochureSvc = {
	submitDetails(formDetails) {
		const params = { email: formDetails.email, name: formDetails.name, accept: true };
		return new Promise((resolve, reject) => {
			axios
				.get(config.brochureAPI, { params })
				.then(result => {
					resolve(result.status === 200 || result.data.status === 'success');
				})
				.catch(err => {
					resolve(false);
					console.error(err);
				});
		});
	},
};

export default brochureSvc;
